import { useCallback, useState } from 'react';
import {
  recordUpdateAttempt,
  resetUpdateAttempts,
  shouldShowRecovery
} from '../lib/updateAttempts';

/**
 * React wrapper over the update-attempt state machine. C.6 calls `record` right
 * before triggering the service-worker update; `reset` runs after a healthy
 * post-reload response. `recoveryActive` flips on once the attempts cross the
 * threshold so the caller can render <UpdateRecoveryScreen/>.
 */
export const useUpdateAttemptCounter = () => {
  const [recoveryActive, setRecoveryActive] = useState<boolean>(() => shouldShowRecovery());

  const record = useCallback(() => {
    recordUpdateAttempt();
    setRecoveryActive(shouldShowRecovery());
  }, []);

  const reset = useCallback(() => {
    resetUpdateAttempts();
    setRecoveryActive(false);
  }, []);

  return { recoveryActive, record, reset };
};
